enum actionTypes {
  CREATE_ORDER = "CREATE_ORDER",
  GET_ORDER_DETAILS = "GET_ORDER_DETAILS",
}

export default actionTypes;
